import React from 'react';
import { ShieldCheck, Truck, RotateCcw, Headphones, CreditCard, Globe, MessageSquare, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer-glass" style={{ marginTop: 'auto', paddingTop: '4rem', paddingBottom: '2rem' }}>
      <div className="main-content" style={{ padding: '0 2rem' }}>

        {/* Trust Badges Section */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '2rem', borderBottom: '1px solid var(--glass-border)', paddingBottom: '3rem', marginBottom: '3rem' }}>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: '1rem' }}>
            <div className="btn-icon" style={{ width: '60px', height: '60px' }}>
              <ShieldCheck size={28} color="var(--primary)" />
            </div>
            <div>
              <h4 style={{ fontSize: '16px', marginBottom: '0.25rem' }}>100% Secure Checkout</h4>
              <p className="text-12">All transactions are heavily encrypted.</p>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: '1rem' }}>
            <div className="btn-icon" style={{ width: '60px', height: '60px' }}>
              <Truck size={28} color="var(--primary)" />
            </div>
            <div>
              <h4 style={{ fontSize: '16px', marginBottom: '0.25rem' }}>Free Express Shipping</h4>
              <p className="text-12">Delivered fresh in pristine condition.</p>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: '1rem' }}>
            <div className="btn-icon" style={{ width: '60px', height: '60px' }}>
              <RotateCcw size={28} color="var(--primary)" />
            </div>
            <div>
              <h4 style={{ fontSize: '16px', marginBottom: '0.25rem' }}>Hassle-Free Returns</h4>
              <p className="text-12">7-Day easy returns guarantees satisfaction.</p>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: '1rem' }}>
            <div className="btn-icon" style={{ width: '60px', height: '60px' }}>
              <Headphones size={28} color="var(--primary)" />
            </div>
            <div>
              <h4 style={{ fontSize: '16px', marginBottom: '0.25rem' }}>Premium 24/7 Support</h4>
              <p className="text-12">We are always available via WhatsApp.</p>
            </div>
          </div>

        </div>

        {/* Links Grid section */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '3rem', marginBottom: '3rem' }}>

          <div>
            <h3 style={{ fontSize: '1.5rem', fontStyle: 'italic', fontWeight: '700', marginBottom: '1rem', color: 'var(--text-main)' }}>HeartyCrafts</h3>
            <p className="text-12" style={{ marginBottom: '1.5rem', lineHeight: '1.8' }}>
              Dedicated to delivering the absolute finest artisan memory gifts and tailored luxury hampers guaranteed to forge unbreakable bonds.
            </p>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <button className="btn-icon" style={{ width: '35px', height: '35px' }}><Globe size={18} /></button>
              <button className="btn-icon" style={{ width: '35px', height: '35px' }}><MessageSquare size={18} /></button>
              <button className="btn-icon" style={{ width: '35px', height: '35px' }}><Mail size={18} /></button>
            </div>
          </div>

          <div>
            <h4 style={{ fontSize: '1.2rem', marginBottom: '1.5rem' }}>Help & Policy</h4>
            <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <li><Link to="/" style={{ color: 'var(--text-muted)', textDecoration: 'none', fontSize: '0.9rem' }}>Track Order</Link></li>
              <li><Link to="/" style={{ color: 'var(--text-muted)', textDecoration: 'none', fontSize: '0.9rem' }}>Return Policy</Link></li>
              <li><Link to="/" style={{ color: 'var(--text-muted)', textDecoration: 'none', fontSize: '0.9rem' }}>Shipping FAQs</Link></li>
              <li><Link to="/" style={{ color: 'var(--text-muted)', textDecoration: 'none', fontSize: '0.9rem' }}>Contact Relations</Link></li>
            </ul>
          </div>

          <div>
            <h4 style={{ fontSize: '1.2rem', marginBottom: '1.5rem' }}>Explore</h4>
            <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <li><Link to="/" style={{ color: 'var(--text-muted)', textDecoration: 'none', fontSize: '0.9rem' }}>Latest Hampers</Link></li>
              <li><Link to="/" style={{ color: 'var(--text-muted)', textDecoration: 'none', fontSize: '0.9rem' }}>Corporate Gifting</Link></li>
              <li><Link to="/" style={{ color: 'var(--text-muted)', textDecoration: 'none', fontSize: '0.9rem' }}>About Us</Link></li>
            </ul>
          </div>

          <div>
            <h4 style={{ fontSize: '1.2rem', marginBottom: '1.5rem' }}>Contact Info</h4>
            <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <li style={{ color: 'var(--text-muted)', fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <Mail size={14} /> mail.heartycrafts@gmail.com
              </li>
              <li style={{ color: 'var(--text-muted)', fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <MessageSquare size={14} /> +91 98840 20566
              </li>
              <li style={{ color: 'var(--text-muted)', fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <Globe size={14} /> Tamil Nadu, India
              </li>
            </ul>
          </div>

        </div>

        {/* Legal Text */}
        <div style={{ textAlign: 'center', borderTop: '1px solid var(--glass-border)', paddingTop: '2rem', color: 'var(--text-muted)', fontSize: '0.85rem' }}>
          <p>© {new Date().getFullYear()} HeartyCrafts Ltd. All rights reserved. Premium Professional Shopping Ecosystem.</p>
          <p style={{ marginTop: '0.5rem', fontSize: '0.75rem', opacity: 0.8 }}>Made with 💙 by Mathi</p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
